// extracted by mini-css-extract-plugin
module.exports = {"container":"VerifiedName_container__1QyLm","name":"VerifiedName_name__2sNf2","icon":"VerifiedName_icon__AzswL","sending":"VerifiedName_sending__3yoED"};